import { FETCH_PERSON_ATTRIBUTES } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

const reducer = hOReducer(FETCH_PERSON_ATTRIBUTES);
export default reducer;
